import { create, type StoreApi, type UseBoundStore } from 'zustand'
import { persist } from 'zustand/middleware'

import type { ImageReaderSettings } from '@/pages/reader/hooks/useImageReaderSettingsQuery'
import type { PdfLayout } from '@/pages/reader/pdf/components/pdf-settings'

export type ReaderLayoutState<T> = {
  /** 最後に選んだ表示設定（初めて開く作品・作品に紐付かないファイルで使う） */
  lastLayout: T | null
  /** 作品（productId）ごとの表示設定 */
  productLayouts: Record<string, T>
  saveLayout: (productId: number | undefined, layout: T) => void
}

export type ReaderLayoutStore<T> = UseBoundStore<StoreApi<ReaderLayoutState<T>>>

const createReaderLayoutStore = <T>(name: string): ReaderLayoutStore<T> =>
  create<ReaderLayoutState<T>>()(
    persist(
      (set) => ({
        lastLayout: null,
        productLayouts: {},
        saveLayout: (productId, layout) =>
          set((state) => ({
            lastLayout: layout,
            productLayouts:
              productId === undefined ? state.productLayouts : { ...state.productLayouts, [productId]: layout },
          })),
      }),
      { name },
    ),
  )

export const usePdfLayoutStore = createReaderLayoutStore<PdfLayout>('pdf-layout')
export const useComicLayoutStore = createReaderLayoutStore<ImageReaderSettings>('comic-layout')
